import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { useLocation } from 'reservations/account/providers/ConfigProvider';
import { useSuccessSnackbar } from 'reservations/base/hooks/useSnackbar';

export const ShareLocationButton = () => {
  const enqueueSuccessSnackbar = useSuccessSnackbar();
  const { lat, lng } = useLocation();
  const url = `https://google.com/maps/search/?api=1&query=${lat},${lng}`;

  const onClick = async () => {
    // Navigator.share is preferable but not supported by all devices. If it exists we use that,
    // otherwise we default to copying to clipboard instead
    if (navigator?.canShare({ url })) {
      try {
        await navigator.share({ url });
      } catch (err) {
        console.warn('Navigation share cancelled due to', err);
      }
    } else {
      navigator.clipboard.writeText(url).then(() => {
        enqueueSuccessSnackbar(
          'LOCATION_URL_COPY_TO_CLIPBOARD',
          'Copied to clipboard'
        );
      });
    }
  };

  return (
    <Button onClick={onClick} variant="secondary" size="fixedWidth">
      <Typography variant="h3">SHARE</Typography>
    </Button>
  );
};
